module.exports = __webpack_public_path__ + "media/70.fab1b785.mp3";